<template>
  <div :class="['carrossel-wrapper', { dark: isDark }]">
    <!-- Seta Esquerda -->
    <button
      class="seta seta-esquerda"
      v-if="podeScrollEsquerda"
      @click="scroll(-1)"
    >
      ‹
    </button>

    <!-- Container de vendedores com scroll -->
    <div
      ref="scrollContainer"
      class="carrossel-vendedores-wrapper"
      @scroll="verificarScroll"
    >
      <div class="carrossel-vendedores">
        <b-card
          v-for="v in vendedores"
          :key="v.id"
          class="vendedor-card text-center"
          :class="{ selecionado: selectedId === v.id }"
          @click="selecionar(v)"
        > 
          <b-avatar
            :text="getIniciais(v.nome)"
            size="4rem"
            class="mb-2"
            :variant="getCor(v.id)"
          />
          <div class="nome">{{ truncarNome(v.nome) }}</div>
          <b-progress :value="v.vendas" :max="100" height="12px" class="mt-2" show-value>
            <b-progress-bar :value="v.vendas" :label="`${v.vendas}%`" />
          </b-progress>
        </b-card>
      </div>
    </div>

    <!-- Seta Direita -->
    <button
      class="seta seta-direita"
      v-if="podeScrollDireita"
      @click="scroll(1)"
    >
      ›
    </button>
  </div>
</template>

<script>
export default {
  name: 'CarrosselVendedores',
  props: {
    vendedores: {
      type: Array,
      required: true
    },
     isDark: Boolean,
     selectedId: [Number, String]
  },
  data() {
    return {
      podeScrollEsquerda: false,
      podeScrollDireita: false
    }
  },
  mounted() {
    this.verificarScroll()
    window.addEventListener('resize', this.verificarScroll)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.verificarScroll)
  },
  methods: {
    selecionar(vendedor){
      // pai decide quem é o selecionado:
      this.$emit('abrir-detalhes', vendedor)
    },
    truncarNome(nome) {
      return nome.length > 15 ? nome.slice(0, 15) + '...' : nome
    },
    getIniciais(nome) {
      if (!nome) return ''
      const partes = nome.trim().split(' ')
      const iniciais = partes.length >= 2
        ? partes[0][0] + partes[1][0]
        : partes[0].slice(0, 2)
      return iniciais.toUpperCase()
    },
    getCor(id) {
      const cores = ['primary', 'info', 'success', 'danger', 'warning', 'secondary', 'dark']
      return cores[id % cores.length]
    },
    scroll(direcao) {
      const container = this.$refs.scrollContainer
      const step = 160 // pixels por clique
      container.scrollBy({
        left: direcao * step,
        behavior: 'smooth'
      })
    },
    verificarScroll() {
      this.$nextTick(() => {
        const el = this.$refs.scrollContainer
        this.podeScrollEsquerda = el.scrollLeft > 0
        this.podeScrollDireita = el.scrollLeft + el.clientWidth < el.scrollWidth
      })
    }
  },
  watch: {
    'isDark': function() {
    }
  },
}
</script>

<style>
.carrossel-wrapper {
  position: relative;
  width: 100%;
}

.carrossel-wrapper.dark .vendedor-card {
  background-color: #2b2b2b;
  color: #fff;
  border: 1px solid #444;
}
.carrossel-wrapper.dark .nome {
  color: #ddd;
}
.carrossel-wrapper.dark .seta {
  background-color: rgba(50, 50, 50, 0.9);
  color: #fff;
}
.carrossel-wrapper.dark .seta:hover {
  background-color: rgba(80, 80, 80, 1);
}

.carrossel-vendedores-wrapper {
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 10px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.carrossel-vendedores-wrapper::-webkit-scrollbar {
  display: none;
}

.carrossel-vendedores {
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
  padding: 0.5rem 1rem;
  min-width: max-content;
}

.vendedor-card {
  flex: 0 0 auto;
  width: 150px;
  padding: 0.75rem;
  cursor: pointer;
  border-radius: 1rem;
  transition: transform 0.2s;
}
.vendedor-card:hover {
  transform: scale(1.05);
  box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.1);
}

.vendedor-card.selecionado {
  border: 2px solid #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.carrossel-wrapper.dark .vendedor-card.selecionado {
  border-color: #66b2ff;
  box-shadow: 0 0 0 2px rgba(102, 178, 255, 0.3);
}

.nome {
  font-size: 0.95rem;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Estilo das setas */
.seta {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  font-weight: bold;
  background-color: rgba(255, 255, 255, 0.85);
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 10;
  padding: 0;
  line-height: 1; /* corrige altura da fonte */
  transition: background 0.2s ease;
}

.seta:hover {
  background-color: rgba(255, 255, 255, 1);
}
.seta-esquerda {
  left: 5px;
}
.seta-direita {
  right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/CarrosselVendedores.vue